const main = {
    NO_INTERNET: "دسترسی به اینترنت وجود ندارد",
    BACK: "برگشت",
    FOOTER: "طراحی و توسعه توسط گروه نگاه",
    APP_NAME: "اینستاکاتالوگ",
    APP_VER: "(نسخه ۱.۰.۳)",
    APP_VER_CODE: 4
}

export default main